import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common_file",
  "use": "icon-common_file-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-common_file\"><path d=\"M896 368v-65.78C896 241.45 852.94 192 800 192H465.36L448 144H128a64 64 0 0 0-64 64v608a64 64 0 0 0 64 64h768a64 64 0 0 0 64-64V432a64 64 0 0 0-64-64z m-96-112c17.34 0 32 21.17 32 46.22V368H529l-40.5-112z m96 560H128V208h275.09l65.72 181.76L484.09 432H896z\" fill=\"#8a8a8a\" p-id=\"4238\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol